module.exports = __webpack_public_path__ + "static/media/learn1.6b453dbf.jpg";